import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/store/store";
import ApiService from './core/services/api.service';
import {VERIFY_AUTH} from "./core/store/modules/auth";
import FirebaseService from "./core/services/firebase.service";
import {RESET_LAYOUT_CONFIG} from "./core/store/modules/config";

Vue.config.productionTip = false;

// eventBus
export const bus = new Vue();

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;

// Vue 3rd party plugins
import "@/core/plugins/metronic";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/portal-vue";
import "@/core/plugins/highlight-js";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/vue-clipboard.js";
import "@/core/plugins/perfect-scrollbar";
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";

// ApiService init
ApiService.init('prod');

// Firebase init
FirebaseService.init();

// Remove this to disable mock API
// MockService.init();

router.beforeEach((to, from, next) => {
   // reset config to initial state
   store.dispatch(RESET_LAYOUT_CONFIG);

   // Ensure we checked auth before each page load.
   Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

   // Scroll page to top on every route change
   setTimeout(() => {
      window.scrollTo(0, 0);
   }, 100);
});

new Vue({
   router,
   store,
   i18n,
   vuetify,
   render: h => h(App)
}).$mount("#app");
